import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConditionSection } from 'admin-common';
import { translatedList } from 'src/app/shared/utils/translated-content';

@Component({
    selector: 'app-general-conditions',
    templateUrl: './general-conditions.component.html',
    styleUrls: ['./general-conditions.component.scss'],
    standalone: false
})
export class GeneralConditionsComponent {
  bigTitle: string = 'homePage.generalConditions.bigTitle';
  contactEmail: string = 'contact@wissalunivers.com';
  infoEmail: string = 'info@wissalunivers.com';
  website: string = 'info@wissalunivers.com';

  /** Texts in the current language; `{website}`, `{contactEmail}` and `{infoEmail}` are filled by lib-general-condition. */
  description: string[];
  conditions: ConditionSection[];

  constructor(translate: TranslateService) {
    this.description = translatedList<string>(translate, 'homePage.generalConditions.description');
    this.conditions = translatedList<ConditionSection>(translate, 'homePage.generalConditions.sections');
  }
}
